import React from "react";
import { withStyles } from "@material-ui/core/styles";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import ToolTip from "../../../../../common/StyledToolTip";
import styles from "./styles";

const Close = ({ classes, onClick }) => (
  <div className={classes.scHeaderCloseButton} onClick={onClick}>
    <ToolTip title="Close window">
      <CloseOutlinedIcon
        className={classes.scHeaderCloseIcon}
      ></CloseOutlinedIcon>
    </ToolTip>
  </div>
);

export default withStyles(styles)(Close);
